module.exports = __webpack_public_path__ + "img/nema.66eb9a75.png";